module.exports = __webpack_public_path__ + "img/deviceManagement.8bf52d8e.svg";